<template>
  <BModal
    id="modal-account-control"
    ref="modal-account-control"
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    hide-header
    size="md"
    :centered="true"
    @hidden="resetForm"
  >
    <div class="d-flex justify-content-end">
      <button
        class="btn p-0"
        @click="$bvModal.hide('modal-account-control')"
      >
        <feather-icon
          icon="XIcon"
          size="20"
          class="text-black"
        />
      </button>
    </div>
    <div class="text-center my-1">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png"
        alt="Warning"
        class="m-auto"
        style="max-width: 120px;"
      >
    </div>
    <h4 class="text-black text-center font-bold mt-1">
      Mengubah Kontrol Akun
    </h4>
    <p class="text-center text-[#828282] my-1 px-2">
      Apakah kamu yakin akan mengubah Kontrol Akun ini menjadi <strong class="text-black">{{ isScore ? 'Input Manual akun' : 'Komcards Score akun' }}</strong>?
    </p>
    <BRow class="flex justify-center mb-2 px-2 mt-3">
      <BCol>
        <BButton
          class="rounded-lg"
          variant="outline-primary"
          block
          @click="$bvModal.hide('modal-account-control')"
        >
          Batal
        </BButton>
      </BCol>
      <BCol>
        <BButton
          class="rounded-lg"
          :variant="isSubmitting ? 'secondary' : 'primary'"
          :disabled="isSubmitting"
          block
          @click="handleSubmit"
        >
          <BSpinner
            v-if="isSubmitting"
            variant="light"
            small
            class="mr-1"
          />
          Konfirmasi
        </BButton>
      </BCol>
    </BRow>
  </BModal>
</template>

<script>
export default {
  props: {
    dataItem: {
      type: Object,
      default: () => ({}),
    },
    isScore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isSubmitting: false,
    }
  },
  methods: {
    resetForm() {
      this.isSubmitting = false
    },
    handleSubmit() {
      this.isSubmitting = true
      this.$emit('confirm', {
        ...this.dataItem,
        isScore: this.isScore,
      })
    },
  },
}
</script>

<style scoped>
</style>
